import {combineReducers} from 'redux';


import admin from './models/admin';


const reducers = combineReducers({
    admin,
});


export default reducers;


// WEBPACK FOOTER //
// ./src/redux/reducers.js